import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/AttachSetting`
//#region AttachSetting相关
const GetList = `${apiUrl}`
const GetInfo = (id: number) => `${apiUrl}/${id}`
const GetNew = (type: number, flag1: number, flag2: number) => `${apiUrl}/new/${type}/${flag1}/${flag2}`
const Delete = (id: number) => `${apiUrl}/${id}`
const PutData = (id: number) => `${apiUrl}/${id}`
const PostData = `${apiUrl}`
//#endregion
export const emptyItem: AttachSettingItemData = {
    Id: 0,
    Flag1Id: 0,
    Flag2Id: 0,
    AttachType: 0,
    AttachName: '',
    Required: false,
    Comments: '',
    Status: 1,
    Sequence: 1,
    Exts: '',
    ArrExts: []
}
export const emptyData: AttachSettingData = {
    Flag1Id: 0,
    Flag1Name: '',
    Flag2Id: 0,
    Flag2Name: '',
    AttachType: 0,
    AttachTypeName: '',
    ItemList: []
}
export interface AttachSettingData {
    [key: string]: any
    Flag1Id: number
    Flag1Name: string
    Flag2Id: number
    Flag2Name: string
    AttachType: number
    AttachTypeName: string

    ItemList: AttachSettingItemData[]
}

export interface AttachSettingItemData {
    [key: string]: any
    Id: number
    Flag1Id: number
    Flag2Id: number
    AttachType: number
    AttachName: string
    Required: boolean
    Exts: string
    Comments: string
    Status: number
    Sequence: number

    ArrExts: string[]
}

export const getList = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}

export const remove = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}

export const getNew = (type: number, flag1: number, flag2: number) => {
    return tryAxios({
        method: 'get',
        url: GetNew(type, flag1, flag2)
    })
}
export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetInfo(id)
    })
}

export const putData = (id: number, form: any) => {
    return tryAxios({
        method: 'put',
        url: PutData(id),
        data: form
    })
}

export const postData = (form: any) => {
    return tryAxios({
        method: 'post',
        url: PostData,
        data: form
    })
}
